import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'striptags',
})
export class StriptagsPipe implements PipeTransform {
  transform(value: string): string {
    if (!value || typeof value !== 'string') {
      return value;
    }

    return value
      .replace(/<[^>]*>?/gm, '')
      .replace(/(\r\n|\n|\r)/gm, "");
  }
}
